import { render, staticRenderFns } from "./BookingDetailsDocumentLandlord.vue?vue&type=template&id=1807b8f3"
import script from "./BookingDetailsDocumentLandlord.vue?vue&type=script&lang=js"
export * from "./BookingDetailsDocumentLandlord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports